var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect, _rect2, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlookIconFy26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9322 9.34307L7.97588 23.8943L6.00165 20.7797V18.0959C6.00165 17.1188 6.49634 16.2081 7.31603 15.6762L20.6606 7.01716C22.6937 5.69792 25.3125 5.69771 27.3458 7.01665L30.9322 9.34307Z",
    fill: "url(#paint0_linear_76780_14576)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1402 6.88928C27.2092 6.93033 27.2777 6.97284 27.3455 7.01682L37.76 13.7724L11.9375 30.1404L7.97498 23.8891L26.9262 11.8533C28.7213 10.7133 28.7999 8.14871 27.1402 6.88928Z",
    fill: "url(#paint1_linear_76780_14576)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1402 6.88928C27.2092 6.93033 27.2777 6.97284 27.3455 7.01682L37.76 13.7724L11.9375 30.1404L7.97498 23.8891L26.9262 11.8533C28.7213 10.7133 28.7999 8.14871 27.1402 6.88928Z",
    fill: "url(#paint2_linear_76780_14576)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2402 33.2659L11.9377 30.1406L33.842 16.2557C35.6868 15.0864 35.682 12.3932 33.8331 11.2304L33.7344 11.1684L34.0185 11.3451L40.685 15.6695C41.5049 16.2014 41.9998 17.1122 41.9998 18.0895V20.687L22.2402 33.2659Z",
    fill: "url(#paint3_linear_76780_14576)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2402 33.2659L11.9377 30.1406L33.842 16.2557C35.6868 15.0864 35.682 12.3932 33.8331 11.2304L33.7344 11.1684L34.0185 11.3451L40.685 15.6695C41.5049 16.2014 41.9998 17.1122 41.9998 18.0895V20.687L22.2402 33.2659Z",
    fill: "url(#paint4_linear_76780_14576)",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3458 7.01665C25.3125 5.69771 22.6937 5.69792 20.6605 7.01716L7.31603 15.6762C6.49634 16.2081 6.00165 17.1188 6.00165 18.0959V18.2272C6.03382 19.208 6.55002 20.1121 7.38373 20.6378L23.9764 31.0985L40.6108 20.6537C41.4747 20.1112 41.999 19.1628 41.999 18.1427V20.6873L41.9994 18.0896C41.9994 17.1123 41.5045 16.2015 40.6846 15.6696L27.3458 7.01665Z",
    fill: "url(#paint5_radial_76780_14576)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0513 42.0035H35.748C39.1998 42.0035 41.998 39.2053 41.998 35.7535L41.998 18.1426C41.998 19.1627 41.4736 20.1111 40.6098 20.6536L18.7495 34.3798C17.5703 35.1202 16.8546 36.4149 16.8547 37.8073C16.8549 40.1248 18.7337 42.0035 21.0513 42.0035Z",
    fill: "url(#paint6_linear_76780_14576)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0513 42.0035H35.748C39.1998 42.0035 41.998 39.2053 41.998 35.7535L41.998 18.1426C41.998 19.1627 41.4736 20.1111 40.6098 20.6536L18.7495 34.3798C17.5703 35.1202 16.8546 36.4149 16.8547 37.8073C16.8549 40.1248 18.7337 42.0035 21.0513 42.0035Z",
    fill: "url(#paint7_radial_76780_14576)",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0513 42.0035H35.748C39.1998 42.0035 41.998 39.2053 41.998 35.7535L41.998 18.1426C41.998 19.1627 41.4736 20.1111 40.6098 20.6536L18.7495 34.3798C17.5703 35.1202 16.8546 36.4149 16.8547 37.8073C16.8549 40.1248 18.7337 42.0035 21.0513 42.0035Z",
    fill: "url(#paint8_radial_76780_14576)",
    fillOpacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0268 42.0023H12.2492C8.79745 42.0023 5.99923 39.2041 5.99923 35.7523V18.1297C5.99923 19.1478 6.52165 20.0948 7.38292 20.6377L29.2215 34.4058C30.4171 35.1595 31.1423 36.4741 31.1421 37.8874C31.1419 40.1601 29.2995 42.0023 27.0268 42.0023Z",
    fill: "url(#paint9_radial_76780_14576)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0268 42.0023H12.2492C8.79745 42.0023 5.99923 39.2041 5.99923 35.7523V18.1297C5.99923 19.1478 6.52165 20.0948 7.38292 20.6377L29.2215 34.4058C30.4171 35.1595 31.1423 36.4741 31.1421 37.8874C31.1419 40.1601 29.2995 42.0023 27.0268 42.0023Z",
    fill: "url(#paint10_linear_76780_14576)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 16,
    height: 16,
    rx: 3.25,
    fill: "url(#paint11_radial_76780_14576)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 16,
    height: 16,
    rx: 3.25,
    fill: "url(#paint12_radial_76780_14576)",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.959 35.5999C10.636 35.5999 9.54994 35.186 8.70069 34.3583C7.85144 33.5306 7.42682 32.4505 7.42682 31.1179C7.42682 29.7107 7.85785 28.5726 8.7199 27.7035C9.58195 26.8345 10.7107 26.3999 12.1062 26.3999C13.4249 26.3999 14.4982 26.8158 15.3261 27.6477C16.1583 28.4795 16.5744 29.5762 16.5744 30.9378C16.5744 32.3367 16.1433 33.4644 15.2813 34.3211C14.4235 35.1736 13.3161 35.5999 11.959 35.5999ZM11.9974 33.8431C12.7186 33.8431 13.299 33.5968 13.7386 33.1044C14.1781 32.6119 14.3979 31.9269 14.3979 31.0496C14.3979 30.1349 14.1845 29.4231 13.7578 28.9141C13.331 28.405 12.7613 28.1505 12.0486 28.1505C11.3146 28.1505 10.7235 28.4133 10.2754 28.9389C9.82733 29.4604 9.60328 30.1515 9.60328 31.0123C9.60328 31.8856 9.82733 32.5767 10.2754 33.0857C10.7235 33.5906 11.2975 33.8431 11.9974 33.8431Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9554 35.7233C10.6375 35.7233 9.55551 35.2982 8.7095 34.448C7.8635 33.5977 7.44049 32.4881 7.44049 31.1192C7.44049 29.6737 7.86987 28.5046 8.72864 27.6119C9.5874 26.7191 10.7119 26.2727 12.102 26.2727C13.4157 26.2727 14.4849 26.7 15.3097 27.5545C16.1387 28.409 16.5532 29.5356 16.5532 30.9343C16.5532 32.3712 16.1238 33.5297 15.265 34.4097C14.4105 35.2855 13.3073 35.7233 11.9554 35.7233ZM11.9936 33.9187C12.7121 33.9187 13.2903 33.6657 13.7282 33.1598C14.1661 32.6539 14.385 31.9503 14.385 31.049C14.385 30.1095 14.1724 29.3783 13.7473 28.8554C13.3222 28.3325 12.7546 28.071 12.0447 28.071C11.3134 28.071 10.7246 28.341 10.2782 28.8809C9.83185 29.4165 9.60865 30.1265 9.60865 31.0108C9.60865 31.9078 9.83185 32.6178 10.2782 33.1407C10.7246 33.6593 11.2964 33.9187 11.9936 33.9187Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76780_14576",
    x1: 9.98908,
    y1: 22.3649,
    x2: 30.9322,
    y2: 9.37495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3BD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76780_14576",
    x1: 17.1972,
    y1: 26.7945,
    x2: 28.8562,
    y2: 8.12575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5008,
    stopColor: "#1880E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8587FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76780_14576",
    x1: 25.7005,
    y1: 27.0484,
    x2: 12.7563,
    y2: 16.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236946,
    stopColor: "#448AFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792113,
    stopColor: "#0032B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76780_14576",
    x1: 24.0534,
    y1: 31.1099,
    x2: 44.51,
    y2: 18.0177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A43A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492267,
    stopColor: "#2052CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F20CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76780_14576",
    x1: 29.8281,
    y1: 30.3273,
    x2: 17.3975,
    y2: 19.5708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0045B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669859,
    stopColor: "#0D1F69"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_76780_14576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0018 6.81788) rotate(-90) scale(27.0027 29.2262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.568182,
    stopColor: "#275FF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992424,
    stopColor: "#002177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_76780_14576",
    x1: 41.998,
    y1: 29.9431,
    x2: 23.8517,
    y2: 29.9431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196145,
    stopColor: "#0FAFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_76780_14576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0928 37.9117) rotate(-45) scale(11.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259477,
    stopColor: "#0060D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908166,
    stopColor: "#0383F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_76780_14576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6314 46.472) rotate(-52.6577) scale(39.2814 35.5204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.732317,
    stopColor: "#F4A7F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A7F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_76780_14576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5708 27.5319) rotate(123.339) scale(20.7258 53.7859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724349,
    stopColor: "#29C3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_76780_14576",
    x1: 3.45756,
    y1: 37.8723,
    x2: 20.9291,
    y2: 37.8597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205882,
    stopColor: "#6CE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#50D5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_76780_14576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.94291 23.6154) rotate(46.9242) scale(21.0618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.038877,
    stopColor: "#0091FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919119,
    stopColor: "#183DAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_76780_14576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 32.7439) rotate(90) scale(11.2 12.9188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.557796,
    stopColor: "#0FA5F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIconFy26);
export default __webpack_public_path__ + "static/media/Outlook-Icon-FY26.ff8400c2dbf8ff7aacfde10b9fe9f7f2.svg";
export { ForwardRef as ReactComponent };